// import React, { useEffect, useState } from 'react';
// import { Button, ButtonEnums, Input } from '@ohif/ui';
// import InputDate from '../../../../platform/ui/src/components/InputDate/InputDate';
// import { useSearchParams } from '@hooks';
// // import { format } from 'date-fns';

// // import {
// //   Select,
// //   Typography,
// //   InputLabelWrapper,
// //   Icon,
// //   LegacyButtonGroup,
// //   LegacyButton,
// //   TooltipClipboard,
// //   StudyListTable,
// // } from '@ohif/ui';
// function parseDateYYYYMMDD(dateString) {
//   if (dateString === null || dateString === undefined) {
//     return null;
//   }
//   const year = parseInt(dateString.slice(0, 4), 10);
//   const month = parseInt(dateString.slice(4, 6), 10); // Months are 0-based
//   const day = parseInt(dateString.slice(6, 8), 10);
//   return new Date(year, month, day);

// }
// function parseDateDDMMYYYY(dateString) {
//   if (dateString === null || dateString === undefined) {
//     return null;
//   }
//   const day = parseInt(dateString.slice(0, 2), 10);
//   const month = parseInt(dateString.slice(2, 4), 10) - 1; // Months are 0-based
//   const year = parseInt(dateString.slice(4, 8), 10);

//   return new Date(year, month, day);
// }

// export default function ShareValidation(
// ) {
//   // var onSuccess, patientName, dateofBirth, validateOption, isSendSecurly, isPasswordSet, password;

//   // const [validateOption, setValidateOption] = useState('na');

//   // const dateRemote = parseDateYYYYMMDD(dateofBirth);
//   // const patientNameRemote = patientName.split('^')[0];
//   var patientName = ""
//   var dateofBirth = new Date();
//   // var validateOption;
//   var isSendSecurly = 'True';
//   var isPasswordSet = 'True';
//   var password = "";

//   const [dateofBirthLocal, setDateofBirthLocal] = useState<Date>(null);
//   const [dateofBirthLocal2, setDateofBirthLocal2] = useState<string>(null);

//   const [lastNameLocal, setlastNameLocal] = useState('na');
//   const [passwordLocal, setPasswordLocal] = useState('na');

//   const [validationLastNameMessage, setValidationLastNameMessage] = useState('');
//   const [validationPasswordMessage, setValidationPasswordMessage] = useState('');
//   const [validationDOBMessage, setValidationDOBMessage] = useState('');

//   const lowerCaseSearchParams = useSearchParams({ lowerCaseKeys: true });
//   const authCode = lowerCaseSearchParams.get('authCode');

//   // function onAuthinticate() {

//   //   function datesAreEqual(d1, d2) {
//   //     if (!(d1 instanceof Date) || isNaN(d1) || !(d2 instanceof Date) || isNaN(d2)) {
//   //       return false;
//   //     }
//   //     return (
//   //       d1.getUTCFullYear() === d2.getUTCFullYear() &&
//   //       d1.getUTCMonth() === d2.getUTCMonth() &&
//   //       d1.getUTCDate() === d2.getUTCDate()
//   //     );
//   //   }

//   //   function validateDOBAndName(localDOB, remoteDOB, localName, remoteName) {
//   //     let dobValid = false;
//   //     let nameValid = false;

//   //     if (datesAreEqual(localDOB, remoteDOB)) {
//   //       setValidationDOBMessage('');
//   //       dobValid = true;
//   //     } else {
//   //       setValidationDOBMessage('Date is incorrect');
//   //     }

//   //     if ((remoteName || '').toLowerCase() === (localName || '').toLowerCase()) {
//   //       setValidationLastNameMessage('');
//   //       nameValid = true;
//   //     } else {
//   //       setValidationLastNameMessage('Name is incorrect');
//   //     }

//   //     return dobValid && nameValid;
//   //   }

//   //   const passwordCheck = () => {
//   //     if (passwordLocal === password) {
//   //       setValidationPasswordMessage('');
//   //       return true;
//   //     }
//   //     setValidationPasswordMessage('Password is incorrect');
//   //     return false;
//   //   };

//   //   const isPasswordSetBool = String(isPasswordSet).toLowerCase() === "true";
//   //   const isSendSecurlyBool = String(isSendSecurly).toLowerCase() === "true";

//   //   if (isPasswordSetBool && isSendSecurlyBool) {
//   //     let dateString = '';
//   //     if (dateofBirthLocal instanceof Date && !isNaN(dateofBirthLocal)) {
//   //       dateString = dateofBirthLocal.toISOString().split('T')[0];
//   //     } else {
//   //       dateString = String(dateofBirthLocal || '').replace(/-/g, '');
//   //     }
//   //     const parsedDOB = parseDateYYYYMMDD(dateString.replace(/-/g, ''));
//   //     const parsedDOB2 = new Date(dateofBirthLocal2);
//   //     parsedDOB2.setMonth(parsedDOB2.getMonth())
//   //     dateRemote.setMonth(dateRemote.getMonth() - 1)
//   //     console.log(parsedDOB2)
//   //     console.log(dateRemote)
//   //     const dobValid = validateDOBAndName(
//   //       parsedDOB2,
//   //       // dateofBirthLocal,
//   //       dateRemote,
//   //       lastNameLocal,
//   //       patientNameRemote
//   //     );
//   //     const passValid = passwordCheck();

//   //     if (dobValid && passValid) {
//   //       onSuccess();
//   //       return;
//   //     }
//   //     return;
//   //   }

//   //   if (isPasswordSetBool) {
//   //     if (passwordCheck()) {
//   //       onSuccess();
//   //     }
//   //     return;
//   //   }

//   //   if (isSendSecurlyBool) {
//   //     // Ensure local DOB is parsed consistently (strip time part)
//   //     let dateString = '';
//   //     if (dateofBirthLocal instanceof Date && !isNaN(dateofBirthLocal)) {
//   //       dateString = dateofBirthLocal.toISOString().split('T')[0];
//   //     } else {
//   //       dateString = String(dateofBirthLocal || '').replace(/-/g, '');
//   //     }
//   //     const parsedDOB = parseDateYYYYMMDD(dateString.replace(/-/g, ''));
//   //     const parsedDOB2 = new Date(dateofBirthLocal2);
//   //     parsedDOB2.setMonth(parsedDOB2.getMonth())
//   //     dateRemote.setMonth(dateRemote.getMonth() - 1)
//   //     console.log(parsedDOB2)
//   //     console.log(dateRemote)
//   //     const dobValid = validateDOBAndName(
//   //       parsedDOB2,
//   //       dateRemote,
//   //       lastNameLocal,
//   //       patientNameRemote
//   //     );

//   //     if (dobValid) {
//   //       onSuccess();
//   //     }
//   //     return;
//   //   }
//   // }


//   function onAuthinticate() {

//     return true;
//   }

//   return (
//     <div className="w-full">
//       <div className = "">

//         <React.Fragment>
//           <div className="mt-4 mb-2 flex flex-row items-center pl-6">
//             <div className="mr-4 flex w-full flex-col items-justify">
//               {isSendSecurly === 'True' && (
//                 <React.Fragment>
//                   <InputDate
//                     wrapperClass="w-full"
//                     id={'name'}
//                     key={'name'}
//                     label={'Date Of Birth'}
//                     isSortable={false}
//                     onLabelClick={() => { }}
//                     value={dateofBirthLocal}
//                     maxDate={new Date()}
//                     // onChange={(value) => {
//                     //   var dateNew = new Date(value)
//                     //   setDateofBirthLocal(dateNew);
//                     //   // console.log(value);
//                     // }}
//                     onChange={(date) => {
//                       if (!(date instanceof Date) || isNaN(date)) {
//                         setDateofBirthLocal(null);
//                         return;
//                       }
//                       console.log(date)
//                       // Normalize to local midnight to avoid timezone differences
//                       const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
//                       console.log(localDate)
//                       setDateofBirthLocal2(date.toDateString());
//                       // localDate.set
//                       setDateofBirthLocal(localDate);
//                     }}
//                     popperClassName='!relative !top-[-30px]'
//                     sortDirection="ascending"
//                     // dropdownItems={COMMAND_TYPES}
//                     hasDropDown={false}
//                     widthFull="w-full"
//                   // defaultValue={null}
//                   />

//                   {/* <Input
//                   label={'Date Of Birth'}
//                   type="date"
//                   onChange={event => {
//                     console.log(event.target.value);
//                     setDateofBirthLocal(event.target.value);
//                   }}
//                   onKeyDown={event => {
//                     if (event.key === 'Enter') {
//                       onAuthinticate();
//                     }
//                   }}

//                 ></Input> */}
//                   <div className="mt-0 flex flex-row items-center ">
//                     <div className="mr-0 flex w-full flex-row items-center">
//                       <label style={{ color: 'red' }}>{validationDOBMessage}</label>
//                     </div>
//                   </div>

//                   <Input
//                     containerClassName="pt-5"
//                     label={'Last Name'}
//                     type="text"
//                     onChange={event => {
//                       console.log(event.target.value);
//                       setlastNameLocal(event.target.value);
//                     }}
//                     onKeyDown={event => {
//                       if (event.key === 'Enter') {
//                         onAuthinticate();

//                       }
//                     }}
//                   ></Input>
//                   <div className="mt-0 flex flex-row items-center">
//                     <div className="mr-0 flex w-full flex-row items-center">
//                       <label style={{ color: 'red' }}>{validationLastNameMessage}</label>
//                     </div>
//                   </div>

//                 </React.Fragment>
//               )}
//               {isPasswordSet === 'True' && (
//                 <React.Fragment>
//                   <Input
//                     containerClassName="pt-5"
//                     label={'Password'}
//                     type="password"
//                     onChange={event => {
//                       console.log(event.target.value);
//                       setPasswordLocal(event.target.value);
//                     }}
//                     onKeyDown={event => {
//                       if (event.key === 'Enter') {
//                         onAuthinticate();
//                       }
//                     }}
//                   ></Input>
//                   <div className="mt-0 flex flex-row items-center">
//                     <div className="mr-0 flex w-full flex-row items-center">
//                       <label style={{ color: 'red' }}>{validationPasswordMessage}</label>
//                     </div>
//                   </div>
//                 </React.Fragment>
//               )}
//             </div>
//           </div>

//           <div className="mt-3 mb-6 flex flex-row place-items-end justify-end pr-6">
//             <React.Fragment>
//               <Button
//                 onClick={onAuthinticate}
//                 //disabled={disabled}
//                 type={ButtonEnums.type.primary}
//                 size={ButtonEnums.size.medium}
//               >
//                 {'Authenticate'}
//               </Button>
//             </React.Fragment>
//           </div>
//         </React.Fragment>
//       </div>

//     </div>
//   );
// }


import { useSearchParams } from '@hooks';
import React, { useState, useEffect } from "react";
import InputDate from '../../../../platform/ui/src/components/InputDate/InputDate';
import { Button, ButtonEnums, Input } from '@ohif/ui';

export default function LoginPage() {
  const [authCase, setAuthCase] = useState(0); // 1=password, 2=dob+lastname, 3=all
  const [dob, setDob] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [validationLastNameMessage, setValidationLastNameMessage] = useState('');
  const [validationPasswordMessage, setValidationPasswordMessage] = useState('');
  const [validationDOBMessage, setValidationDOBMessage] = useState('');

  const [dateofBirthLocal, setDateofBirthLocal] = useState<Date>(null);
  const [dateofBirthLocal2, setDateofBirthLocal2] = useState<string>(null);

  const [lastNameLocal, setlastNameLocal] = useState('na');
  const [passwordLocal, setPasswordLocal] = useState('na');

  const lowerCaseSearchParams = useSearchParams({ lowerCaseKeys: false });
  const authCode = lowerCaseSearchParams.get('authCode');
  useEffect(() => {
    // Fetch which case to show based on server API
    async function fetchAuthCase() {
      try {
        //0340cbaa-0cbb-4060-87eb-9e217919fca9
        const res = await fetch(window.config.baseURLDicomWebAPI_Share + "GetOptions?authCode=" + authCode); // replace with real API
        const data = await res.json();
        setAuthCase(data.choice); // expected 1, 2, or 3
      } catch (err) {
        setError("Failed to load authentication case");
      }
    }
    fetchAuthCase();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      //          baseURl: window.config.baseURLDicomWebAPI_Share.replace("OhifAuth/", ""),
      // Post authentication details


      // Create Date object
      const date = new Date(dateofBirthLocal2);

      // Format as YYYYMMDD
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      const formatted = `${year}${month}${day}`;

      const res = await fetch(window.config.baseURLDicomWebAPI_Share
        // .replace("OhifAuth/", "")
        + "ValidateAPI?authCode=" + authCode + "&lastName=" + lastNameLocal + "&dateOfBirth=" + formatted + "&password=" + passwordLocal, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        // body: JSON.stringify({ dob, lastName, password, authcode: "XYZ" })
      });

      const jsonResponse = await res.json();  // or response.json() if API returns JSON
      if (!res.ok) {
        if (!jsonResponse.lastnameValidated) {
          setValidationLastNameMessage("Name is Incorrect")
        } else {
          setValidationLastNameMessage("")
        }
        if (!jsonResponse.dateOfBirthValidated) {
          setValidationDOBMessage("Date is Incorrect")
        } else {
          setValidationDOBMessage("")
        }
        if (!jsonResponse.passwordValidated) {
          setValidationPasswordMessage("Password is Incorrect")
        } else {
          setValidationPasswordMessage("")
        }
        throw new Error("Authentication failed");
      }
      // const data = await res.json();
      // Redirect to OHIF with token from server
      window.location.href = `${jsonResponse.url}`;
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#000000]">
      {/* // bg-gray-100"> */}
      <div className="w-full max-w-md bg-[#041c49] rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-center text-white mb-6 ">
          Authenticate
        </h2>

        {/* {error && <p className="text-red-600 text-center mb-4">{error}</p>} */}

        {!authCase ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : (
          <form className="space-y-5" onSubmit={handleSubmit}>
            {(authCase === 2 || authCase === 3) &&
              (
                <React.Fragment>
                  <InputDate
                    wrapperClass="w-full"
                    id={'name'}
                    key={'name'}
                    label={'Date Of Birth'}
                    isSortable={false}
                    onLabelClick={() => { }}
                    value={dateofBirthLocal}
                    maxDate={new Date()}
                    // onChange={(value) => {
                    //   var dateNew = new Date(value)
                    //   setDateofBirthLocal(dateNew);
                    //   // console.log(value);
                    // }}
                    onChange={(date) => {
                      if (!(date instanceof Date) || isNaN(date)) {
                        setDateofBirthLocal(null);
                        return;
                      }
                      console.log(date)
                      // Normalize to local midnight to avoid timezone differences
                      const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                      console.log(localDate)
                      console.log(date.toDateString())

                      setDateofBirthLocal2(date.toDateString());
                      // localDate.set
                      setDateofBirthLocal(localDate);
                    }}
                    // popperClassName='!relative !top-[-30px]'
                    sortDirection="ascending"
                    // dropdownItems={COMMAND_TYPES}
                    hasDropDown={false}
                    widthFull="w-full"
                  // defaultValue={null}
                  />

                  {/* <Input
                label={'Date Of Birth'}
                type="date"
                onChange={event => {
                  console.log(event.target.value);
                  setDateofBirthLocal(event.target.value);
                }}
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    onAuthinticate();
                  }
                }}

              ></Input> */}
                  {validationDOBMessage && validationDOBMessage != "" &&
                    (<div className="mt-0 flex flex-row items-center">
                      <div className="mr-0 flex w-full flex-row items-center">
                        <label style={{ color: 'red' }}>{validationDOBMessage}</label>
                      </div>
                    </div>)
                  }

                  <Input
                    containerClassName=""
                    label={'Last Name'}
                    type="text"
                    onChange={event => {
                      console.log(event.target.value);
                      setlastNameLocal(event.target.value);
                    }}
                    onKeyDown={event => {
                      if (event.key === 'Enter') {
                        // onAuthinticate();

                      }
                    }}
                    labelClassName='text-white'
                  ></Input>
                  {validationLastNameMessage && validationLastNameMessage != "" &&
                    (<div className="mt-0 flex flex-row items-center">
                      <div className="mr-0 flex w-full flex-row items-center">
                        <label style={{ color: 'red' }}>{validationLastNameMessage}</label>
                      </div>
                    </div>)
                  }

                </React.Fragment>
              )
              // (
              //   <>
              //     <div>
              //       <label className="block text-gray-600 mb-1">Date of Birth</label>
              //       <input
              //         type="date"
              //         value={dob}
              //         onChange={(e) => setDob(e.target.value)}
              //         required
              //         className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
              //       />
              //     </div>
              //     <div>
              //       <label className="block text-gray-600 mb-1">Last Name</label>
              //       <input
              //         type="text"
              //         value={lastName}
              //         onChange={(e) => setLastName(e.target.value)}
              //         required
              //         className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
              //         placeholder="Enter your last name"
              //       />
              //     </div>
              //   </>
              // )
            }

            {(authCase === 1 || authCase === 3) &&
              (
                <React.Fragment>
                  <Input
                    containerClassName=""
                    label={'Password'}
                    type="password"
                    onChange={event => {
                      console.log(event.target.value);
                      setPasswordLocal(event.target.value);
                    }}
                    onKeyDown={event => {
                      if (event.key === 'Enter') {
                        // onAuthinticate();
                      }
                    }}
                    labelClassName='text-white'
                  ></Input>
                  {validationPasswordMessage && validationPasswordMessage != "" &&
                    (<div className="mt-0 flex flex-row items-center">
                      <div className="mr-0 flex w-full flex-row items-center">
                        <label style={{ color: 'red' }}>{validationPasswordMessage}</label>
                      </div>
                    </div>)
                  }
                </React.Fragment>
              )
              // (
              //   <div>
              //     <label className="block text-gray-600 mb-1">Password</label>
              //     <input
              //       type="password"
              //       value={password}
              //       onChange={(e) => setPassword(e.target.value)}
              //       required
              //       className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
              //       placeholder="Enter your password"
              //     />
              //   </div>
              // )
            }


            <button
              type="submit"
              disabled={loading}
              className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
            >
              {loading ? "Authenticating..." : "Authenticate"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
